export const formateCoins = (number) => {
    if(number==null) return 0;
    if (number >= 1000000) {
        return (number / 1000000).toFixed(1) + 'M';
    } else if (number >= 1000) {
        return (number / 1000).toFixed(1) + 'K';
    } else {
        return number.toString();
    }
};

export const formatMoney = (amount) => {
  return parseFloat(amount).toFixed(2);
};
// export const promotion = (price, promotion) => {
//     const pricePromotion = (price - (price * promotion / 100)).toFixed(2);
//     return parseFloat(pricePromotion); 
// };
export const promotion = (price, promotion) => {
    if (!promotion || promotion === 0) {
        return parseFloat(price).toFixed(2);
    }
    const pricePromotion = (price - (price * promotion / 100)).toFixed(2);
    return pricePromotion; // Retourne une string au lieu de parseFloat
};
export const newpromotion = (price, promotion=0) => {
    const p = parseFloat(price);
    const promo = parseFloat(promotion);
  
    if (isNaN(p) || isNaN(promo)) return 0;
  
    const pricePromotion = (p + (p * promo / 100)).toFixed(2);
    return parseFloat(pricePromotion);
  };
  